import { apiDocsConfigRef, defaultDefinitionWidgets } from '@backstage/plugin-api-docs';
import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';

import { OpenApiWithPkce } from './OpenApiWithPkce';

// Replaces the native `api:api-docs/config`.
const openApiApiExtension = ApiBlueprint.make({
  name: 'config',
  params: defineParams =>
    defineParams({
      api: apiDocsConfigRef,
      deps: {},
      factory: () => {
        const widgets = defaultDefinitionWidgets();
        const openapi = widgets.find(widget => widget.type === 'openapi')!;

        return {
          getApiDefinitionWidget(api) {
            if (api.spec?.type === 'openapi') {
              return {
                ...openapi,
                component: OpenApiWithPkce,
              };
            }

            return widgets.find(widget => widget.type === api.spec?.type);
          },
        };
      },
    }),
});

const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [openApiApiExtension],
});

export default apiDocsModule;
